module.exports = __webpack_public_path__ + "static/media/arrow_left.3d01903f.svg";